import { GoArrowLeft  } from "react-icons/go";
import { CiShuffle,CiGrid2H,CiClock1,CiStar   } from "react-icons/ci";
import { CloudArrowUpIcon, LockClosedIcon, ServerIcon } from '@heroicons/react/20/solid'
export const Sagis = () => {


  return (
      <div>
          <div className="relative isolate overflow-hidden bg-white  lg:overflow-visible lg:px-0">

              <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8  lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
                  <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8">
                      <div className="lg:pr-4">
                          <div className="lg:max-w-lg">
                              <a href={"/company/integrations"} className="text-sm items-center flex font-semibold text-indigo-600"><GoArrowLeft className={"h-5 w-5 mr-2"}/>Zurück</a>
                              <h1 className="mt-2 text-2xl font-semibold tracking-tight text-pretty text-gray-900 ">
                                  SAGis - XPlanung
                              </h1>
                              <p className="mt-6 text-sm text-gray-700">
                                  Von PDF zu XPlanung – jetzt direkt aus Sagis.Xplanung an XPLANUNG24 übermitteln
                              </p>
                          </div>
                      </div>
                  </div>
                  <div className="-mt-12 -ml-12 p-12 lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
                      <img
                          alt=""
                          src={`${process.env.PUBLIC_URL}/integrations/sagis/mainImage.png`}
                          className="rounded-xl  ring-1 ring-gray-400/10 "
                      />
                  </div>
                  <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 ">
                      <div className="lg:pr-4">
                          <div className="max-w-xl text-sm text-gray-700 lg:max-w-lg">
                              <p>
                                  Mit Sagis.Xplanung wird der Einstieg in die digitale Bauleitplanung einfacher denn je. Dank der neuen Funktion können Pläne jetzt direkt aus PDF-Dateien in das XPlanGML-Format überführt werden – schnell, zuverlässig und ohne zusätzliche Software.<br/><br/>
                                  Neu: Durch die Kooperation mit XPLANUNG24 lassen sich die erzeugten XPlan-Daten mit wenigen Klicks direkt aus Sagis.Xplanung an das zentrale Portal übertragen. So wird nicht nur die Erstellung, sondern auch die Veröffentlichung XPlan-konformer Daten zum Kinderspiel.
                              </p>
                              <ul role="list" className="mt-8 space-y-8 text-gray-600">
                                  <li className="flex items-center gap-x-3">
                                      <CiShuffle aria-hidden="true" className="mt-1 size-8 flex-none text-indigo-600" />
                                      <span>
                                        <strong className="font-semibold text-gray-900">Schnelle Konvertierung</strong>  von PDF-Plänen in XPlan-konforme Daten
                                      </span>
                                  </li>
                                  <li className="flex items-center  gap-x-3">
                                      <CiGrid2H  aria-hidden="true" className="mt-1 size-8 flex-none text-indigo-600" />
                                      <span>
                                        <strong className="font-semibold text-gray-900">Nahtlose Integration</strong>  mit dem Portal XPLANUNG24
                                      </span>
                                  </li>
                                  <li className="flex items-center  gap-x-3">
                                      <CiClock1  aria-hidden="true" className="mt-1 size-8 flex-none text-indigo-600" />
                                      <span>
                                        <strong className="font-semibold text-gray-900">Zeitersparnis</strong>  bei der Bereitstellung Ihrer Planwerke
                                      </span>
                                  </li>
                                  <li className="flex items-center  gap-x-3">
                                      <CiStar  aria-hidden="true" className="mt-1 size-8 flex-none text-indigo-600" />
                                      <span>
                                        <strong className="font-semibold text-gray-900">Ideal</strong>  für Kommunen, Planungsbüros und Datenbereitsteller
                                      </span>
                                  </li>
                              </ul>

                              <h2 className="mt-16 text-xl font-bold tracking-tight text-gray-900">Installationsanleitung: SAGis XPlanung Plugin für QGIS</h2>
                              <p className="mt-6">
                                  <div className={"border bg-gray-300 h-[300px] w-full border-gray-400 my-4  rounded"}>
                                      Video folgt
                                  </div>
                              </p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  )
}
